// This file is used to run function on every page view. You should ensure idempotency for anything running here for efficiency reasons. This file is included in the global scripts and will run on every page view, but can be dependent on other global scripts.
// This runs even before the document is ready, so it's use should be exceedingly rare

SaDateTimeUtils.setUserTimeZoneIfNotExists();
